// File: src/components/Sidebar.js
import React from "react";
import { useNavigate } from "react-router-dom";
import {useContext } from "react";
import {
  FaHome,
  FaPenFancy,
  FaBookmark,
  FaProjectDiagram,
  FaBriefcase,
  FaExchangeAlt,
  FaUserFriends,
  FaUtensils,
  FaRobot,
  // FaUserSecret, // used by the hidden "What Helia Is Like" entry
} from "react-icons/fa";
import { MobileViewContext } from "../context/MobileViewContext";


// Main Menu Items With Icons
const menuItems = [
  { name: "Home", path: "/", icon: <FaHome /> },
  // Hidden from the menu for now; the page and its route still work.
  // { name: "What Helia Is Like", path: "/what-helia-is-like", icon: <FaUserSecret /> },
  { name: "Writing", path: "/writing", icon: <FaPenFancy /> },
  { name: "AI Reports", path: "/ai-reports", icon: <FaRobot /> },
  { name: "Bookmarks", path: "/bookmarks", icon: <FaBookmark /> },
  { name: "Recipes", path: "/recipes", icon: <FaUtensils /> },
  { name: "Projects", path: "/projects", icon: <FaProjectDiagram /> },
  { name: "Work", path: "/work", icon: <FaBriefcase /> },
  { name: "Interactive", path: "/interactive", icon: <FaExchangeAlt /> },
  { name: "Social Media", path: "/social-media", icon: <FaUserFriends /> },
];

export default function Sidebar({ activeMenu, setActiveMenu }) {
  const {setMobileView} = useContext(MobileViewContext);
  
  const navigate = useNavigate();

  const handleClick = (item) => {
    setActiveMenu(item.name);
    navigate(item.path);
  };

  return (
    <div className="left-sidebar">
      {menuItems.map((item) => (
        <div
          key={item.name}
          className={`sidebar-item ${activeMenu === item.name ? "active" : ""}`}
          onClick={() => {handleClick(item);
                          setMobileView("toc2")
          }}
        >
          <span className="sidebar-icon">{item.icon}</span>
          <span className="sidebar-text">{item.name}</span>
        </div>
      ))}
    </div>
  );
}
